const reportMainDataActions = {
  REPORT_MAIN_DATA_INIT: 'REPORT_MAIN_DATA_INIT',
  REPORT_MAIN_DATA_SET: 'REPORT_MAIN_DATA_SET',
};
export default reportMainDataActions;
